export enum ReasonType {
    yellow = "yellow",
    red = "red",
}
